import {DrawerActions, useNavigation} from '@react-navigation/native';
import {
  Icon,
  Text,
  TopNavigation,
  TopNavigationAction,
} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {default as theme} from '../../../assets/json/custom-theme.json';
import {px} from '../../../utils';

const BackIcon = (props) => (
  <Icon
    {...props}
    fill={'white'}
    style={[props.style, styles.icon]}
    name="arrow-ios-back-outline"
  />
);

const DrawerIcon = (props) => (
  <Icon
    {...props}
    fill="white"
    style={[props.style, styles.icon]}
    name="menu-outline"
  />
);

const PageHeader = ({
  title,
  accessoryRight,
  showDrawerAction = false,
  showBackAction = true,
}) => {
  const navigation = useNavigation();

  const renderTitle = () => <Text style={styles.title}>{title}</Text>;

  const renderBackAction = () => (
    <TopNavigationAction icon={BackIcon} onPress={navigation.goBack} />
  );

  const renderDrawerAction = () => (
    <TopNavigationAction
      icon={DrawerIcon}
      onPress={() => navigation.dispatch(DrawerActions.openDrawer())}
    />
  );

  return (
    <TopNavigation
      alignment="start"
      title={renderTitle}
      accessoryLeft={
        showDrawerAction
          ? renderDrawerAction
          : showBackAction
          ? renderBackAction
          : undefined
      }
      accessoryRight={accessoryRight}
      style={styles.container}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme['color-warning-500'],
    height: px(60),
  },
  title: {
    color: 'white',
    fontSize: px(20),
    lineHeight: px(26),
    marginLeft: 15,
  },
  icon: {
    width: px(32),
    height: px(32),
  },
});

export default PageHeader;
